<template>
  <header v-if="!isMobile"
          class="masthead"
         :class="{'justify-content-between': displayMenu(), 'justify-content-end':!displayMenu()}">
      <nav v-if="displayMenu()"
        class="animate__animated animate__slideInDown d-flex">
        <router-link :to="{name: 'Home'}">
          <img class="brand" src="@/assets/images/VTStack_logo.svg" alt="">
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'graph_assets',}}"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Graph.svg" alt="graphs">
          <div class="nav-link-text">{{ $t('button.graph.raw.short') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'design_assets',}}"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Design.svg" alt="design">
          <div class="nav-link-text">{{ $t('button.design.raw.short') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'sound_assets',}}"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Sound.svg" alt="son">
          <div class="nav-link-text">{{ $t('button.sound.raw.short') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'support_assets',}}"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Support.svg" alt="support">
          <div class="nav-link-text">{{ $t('button.support.raw.short') }}</div>
        </router-link>
      </nav>
      <div class="d-flex align-items-center">
        <div class="px-4 cursor-hand" >
          <a :href="$t('link.button.vts.editor')">
            <span class="btn_vts"> {{$t('button.vts.editor')}} </span>
          </a>
        </div>
        <div class="lang-switcher">
          <img :src="require('@/assets/images/flags/'+currentLocale+'.svg')"
               :alt="'flag_'+currentLocale"
          @click="switchLocale()"/>
        </div>
        <div v-if="isAuthenticated"
             class="user-info d-flex ml-auto align-items-center pl-4">
          <img
            v-if="this.checkGravatar(currentUser.login)"
              class="cover-fit border-pad w-50px h-50px"
              :src="currentUser.avatarUrl"
              alt="">
          <div v-else class="user-info__image
              rounded-circle position-relative">
            <div class="avatar-placeholder">
              {{currentUser.initials}}
            </div>
          </div>
          <div class="pl-4 cursor-hand"
               @click.stop="logout">
            <span class="logout"> {{$t('profile.logout')}} </span>
          </div>
        </div>
        <div v-else class="pl-4 cursor-hand"
             @click.stop="login">
          <span class="signon"> {{$t('profile.login')}} </span>
        </div>
      </div>
  </header>
  <header v-else
          class="masthead"
          :class="{'justify-content-between': displayMenu(), 'justify-content-end':!displayMenu()}">
    <nav v-if="displayMenu()"
         class="animate__animated animate__slideInDown">
      <div class="d-flex justify-content-between p-3 vw-100">
        <router-link :to="{name: 'Home'}">
          <img class="brand" src="@/assets/images/VTStack_logo.svg" alt="">
        </router-link>
        <a
          class="burger"
          @click="displayMobileMenu">
          <img class="w-100" src="@/assets/images/icons/Icon_Btn_Menu.svg">
        </a>
      </div>
      <div ref="mobileMenu" class="menu-mobile">
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'graph_assets',}}"
                     @click="displayMobileMenu"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Graph.svg" alt="graphs">
          <div class="nav-link-text">{{ $t('button.graph.raw') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'design_assets',}}"
                     @click="displayMobileMenu"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Design.svg" alt="design">
          <div class="nav-link-text">{{ $t('button.design.raw') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'sound_assets',}}"
                     @click="displayMobileMenu"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Sound.svg" alt="sound">
          <div class="nav-link-text">{{ $t('button.sound.raw') }}</div>
        </router-link>
        <router-link :to="{name: 'ProductsView', params: {productCategory: 'support_assets',}}"
                     @click="displayMobileMenu"
                     class="nav-link">
          <img class="nav-link-icon" src="@/assets/images/icons/Icon_Btn_Support.svg" alt="support">
          <div class="nav-link-text">{{ $t('button.support.raw') }}</div>
        </router-link>
        <div class="d-flex pt-6 align-items-center">
          <div>
            <div class="lang-switcher">
              <img :src="require('@/assets/images/flags/'+currentLocale+'.svg')"
                   :alt="'flag_'+currentLocale"
                   @click="switchLocale()"/>
            </div>
          </div>
          <div v-if="isAuthenticated"
               class="user-info d-flex ml-auto align-items-center cursor-hand pl-4">
            <div class="user-info__image rounded-circle position-relative">
              <img
              v-if="this.checkGravatar(currentUser.login)"
                class="cover-fit border-pad w-50px h-50px"
                :src="currentUser.avatarUrl"
                alt="">
              <div v-else class="avatar-placeholder">
                {{currentUser.initials}}
              </div>
            </div>
            <div class="pl-4 cursor-hand"
                 @click.stop="logout">
              <span> {{$t('profile.logout')}} </span>
            </div>
          </div>
          <div v-else class="pl-4 cursor-hand"
               @click.stop="login">
            <span> {{$t('profile.login')}} </span>
          </div>
        </div>
    </div>
    </nav>
    <div v-else>
      <div class="d-flex pt-3 pr-4 align-items-center">
        <div>
          <div class="lang-switcher">
            <img :src="require('@/assets/images/flags/'+currentLocale+'.svg')"
                 :alt="'flag_'+currentLocale"
                 @click="switchLocale()"/>
          </div>
        </div>
        <div v-if="isAuthenticated"
             class="user-info d-flex ml-auto align-items-center cursor-hand pl-4">
          <div class="user-info__image rounded-circle position-relative">
            <img
              v-if="this.checkGravatar(currentUser.login)"
              class="cover-fit border-pad w-50px h-50px"
              :src="currentUser.avatarUrl"
              alt="">
            <div v-else class="avatar-placeholder">
              {{currentUser.initials}}
            </div>
          </div>
          <div class="pl-4 cursor-hand"
               @click.stop="logout">
            <span class="logout"> {{$t('profile.logout')}} </span>
          </div>
        </div>
        <div v-else class="pl-4 cursor-hand"
             @click.stop="login">
          <span class="signon"> {{$t('profile.login')}} </span>
        </div>
      </div>
    </div>
  </header>
</template>
<script>

import { mapGetters } from 'vuex';
import { LOGIN, LOGOUT } from '@/store/actions.type';
import store from '@/store';
import HelperMixin from '@/mixins/helperMixin';
import { saveUrlReferer } from '@/common/referer.service';

export default {
  name: 'TheHeader',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated']),
  },
  methods: {
    displayMenu() {
      return this.$route.name !== 'Home';
    },
    displayMobileMenu() {
      const menu = this.$refs.mobileMenu;
      if (menu.classList.contains('active')) {
        menu.classList.remove('active');
      } else {
        menu.classList.add('active');
      }
    },
    login() {
      saveUrlReferer(this.$route.path);
      store.dispatch(LOGIN);
    },
    logout() {
      store.dispatch(LOGOUT);
      this.$router.go();
    },
    switchLocale() {
      const locale = this.currentLocale === 'fr' ? 'en' : 'fr';
      this.currentLocale = locale;
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('lang', locale);
        const to = this.$router.resolve({ params: { locale } });
        this.$router.push(to);
      }
    },
  },
  data() {
    return {
      currentLocale: this.$i18n.locale,
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
    };
  },
  /* eslint-disable */
  watch: {
    $route(to, from) {
      const { audioPlayer } = this.$parent;
      if(audioPlayer){
        if (audioPlayer.duration > 0 && !audioPlayer.paused) {
          audioPlayer.pause();
          audioPlayer.dispatchEvent(new Event('pause'));
          this.audioPlaying = false;
        }
      }

    }
  }
  /* eslint-enable */
};
</script>
